// extracted by mini-css-extract-plugin
module.exports = {"anchor":"TopBarLinks_anchor__bZ8dw"};